import React, { useEffect, useState } from 'react'
import {
  Btn,
  CustomCalendar,
  CustomDropdown,
  CustomInputTextArea,
  CustomModal,
  InputNumeroDecimal,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { parseToMysqlFormat } from '../../../../services/util/date.service'
import MovimentacaoLastMileHttp from '../../../../services/api/https/patrimonio/movimentacao-last-mile.http'
import { errorHandler } from '../../../../services/util/error.service'
import { getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'

const INITIAL_STATE = {
  id: null,
  observacoes: '',
  data_movimentacao: '',
  selectedPlaca: '',
  selectedTransportadora: '',
  selectedPatrimonioOwner: '',
  ativos: [],
}

export default function ModalMovimentacaoLastMile({
  visible,
  selectedMovimentacao,
  onResponse,
  selectedTp,
}) {
  const [movimentacao, setMovimentacao] = useState({ ...INITIAL_STATE })
  const [placas, setPlacas] = useState([])
  const [transportadoras, setTransportadoras] = useState([])
  const [ativos, setAtivos] = useState([])
  const [owners, setOwners] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [ativosTp, setAtivosTp] = useState([])
  const [ativosByOwner, setAtivosByOwner] = useState(null)

  useEffect(() => {
    if (selectedMovimentacao) {
      populateAtivos(selectedMovimentacao.ativos)
      setMovimentacao({
        ...selectedMovimentacao,
        selectedPlaca: getSelectedPlaca(selectedMovimentacao.veiculo_entrega_id),
        selectedTransportadora: getSelectedTransportadora(selectedMovimentacao.transportadora_id),
        selectedPatrimonioOwner: getSelectedPatrimonioOwner(
          selectedMovimentacao.patrimonio_owner_id,
        ),
      })
    } else {
      setMovimentacao({ ...INITIAL_STATE })
    }
  }, [visible])

  useEffect(() => {
    if (selectedTp) {
      MovimentacaoLastMileHttp.formInitInfo(selectedTp, getUsuarioInfo().id)
        .then(info => {
          setPlacas([...info.placas])
          setTransportadoras([...info.transportadoras])
          setAtivos([...info.ativos])
          setAtivosTp([...info.ativos])
          setOwners([...info.owners])
        })
        .catch(error => {
          onResponse('error', errorHandler(error))
        })
    }
  }, [selectedTp])

  // Events
  const onQuantidadeChange = (ativo, value) => {
    setAtivosByOwner(prevState => {
      const index = prevState.findIndex(a => a.ativo_id === ativo.ativo_id)
      if (index !== -1) {
        prevState[index].qte = value
      }
      return [...prevState]
    })
  }

  const onBtnSalvarClick = async () => {
    try {
      setIsLoading(true)
      runValidation(ativosByOwner)
      const mov = {
        id: movimentacao.id,
        tp_id: selectedTp,
        data_movimentacao: parseToMysqlFormat(movimentacao.data_movimentacao),
        veiculo_entrega_id: movimentacao.selectedPlaca.vehicle_id,
        transportadora_id: movimentacao.selectedTransportadora.transportadora_id,
        ativos: ativosByOwner.filter(a => a.qte).map(a => ({ ...a, qte: Number(a.qte) })),
        prestacao_conta_status: movimentacao.id ? movimentacao.prestacao_conta_status : 'Pendente',
        created_by_user_id: getUsuarioInfo().id,
        patrimonio_owner_id: movimentacao.selectedPatrimonioOwner.owner_id,
        observacoes: movimentacao.observacoes,
      }
      const savedMovimentacao = await MovimentacaoLastMileHttp.saveMovimentacao(mov)
      onResponse('success', savedMovimentacao)
    } catch (e) {
      onResponse('error', errorHandler(e))
    } finally {
      setIsLoading(false)
    }
  }

  // Helpers
  const runValidation = ativos => {
    if (movimentacao.data_movimentacao === '') {
      throw new Error('Campo Data de Movimentação é obrigatório')
    } else if (movimentacao.selectedPlaca === '') {
      throw new Error('Campo Placa é obrigatório')
    } else if (movimentacao.selectedTransportadora === '') {
      throw new Error('Campo Transportadora é obrigatório')
    } else {
      let todosAtivosPossuemQteIgualZero = true
      for (const ativo of ativos) {
        const nQte = Number(ativo.qte)
        if (Number.isNaN(nQte) || nQte < 0) {
          throw new Error(`Qte incorreta para o patrimonio: ${ativo.ativo_name}`)
        }
        if (nQte > 0 && todosAtivosPossuemQteIgualZero) {
          todosAtivosPossuemQteIgualZero = false
        }
      }
      if (todosAtivosPossuemQteIgualZero) {
        throw new Error(`Pelo menos 01(um) ativo deve ter quantidade MAIOR que ZERO`)
      }
    }
  }

  const populateAtivos = () => {
    if (selectedMovimentacao && selectedMovimentacao.ativos.length > 0) {
      const dataTableAtivos = []
      ativosTp.forEach(a => {
        const ativo = selectedMovimentacao.ativos.find(
          at =>
            at.ativo_id === a.ativo_id && selectedMovimentacao.patrimonio_owner_id === a.owner_id,
        )
        if (ativo) {
          dataTableAtivos.push({
            ativo_id: a.ativo_id,
            ativo_name: a.ativo_name,
            qte: ativo.qte,
          })
        } else {
          dataTableAtivos.push({
            ativo_id: a.ativo_id,
            ativo_name: a.ativo_name,
            qte: '',
          })
        }
      })
      setAtivosByOwner([...dataTableAtivos])
    } else {
      setAtivos(ativosTp.map(at => ({ ...at, qte: '' })))
    }
  }

  const getSelectedPlaca = veiculoEntregaId => {
    const sPlaca = placas.find(p => p.vehicle_id === veiculoEntregaId)
    return sPlaca ? sPlaca : ''
  }

  const getSelectedTransportadora = transportadoraId => {
    const sTransportadora = transportadoras.find(t => t.transportadora_id === transportadoraId)
    return sTransportadora ? sTransportadora : ''
  }

  const getSelectedPatrimonioOwner = patrimonioOwnerId => {
    const sPatrimonioOwner = owners.find(o => o.owner_id === patrimonioOwnerId)
    return sPatrimonioOwner ? sPatrimonioOwner : ''
  }

  useEffect(() => {
    if (selectedMovimentacao && !selectedMovimentacao.id) {
      const ativosFromOwner = ativos.filter(
        a => a.owner_id === movimentacao.selectedPatrimonioOwner.owner_id,
      )
      setAtivosByOwner(ativosFromOwner)
    }
  }, [movimentacao.selectedPatrimonioOwner])

  // Render
  return (
    <CustomModal
      header={
        movimentacao && movimentacao.id
          ? 'Editando Movimentação - Last Mile'
          : 'Nova Movimentação - Last Mile'
      }
      isVisible={visible}
      width={600}
      onClose={() => onResponse('close')}
    >
      <div className="p-grid">
        <div className="p-col-12">
          <CustomCalendar
            label={'Data da Movimentação*'}
            value={movimentacao.data_movimentacao}
            onChange={value =>
              setMovimentacao(prevState => ({ ...prevState, data_movimentacao: value }))
            }
          />
        </div>
        <div className="p-col-6">
          <CustomDropdown
            label={'Placa Veículo Entrega*'}
            value={movimentacao.selectedPlaca}
            onChange={value => {
              setMovimentacao(prevState => ({ ...prevState, selectedPlaca: value }))
            }}
            options={placas}
            optionLabel={'vehicle_badge'}
            filter={true}
          />
        </div>
        <div className="p-col-6">
          <CustomDropdown
            label={'Transportadora*'}
            value={movimentacao.selectedTransportadora}
            onChange={value => {
              setMovimentacao(prevState => ({ ...prevState, selectedTransportadora: value }))
            }}
            options={transportadoras}
            optionLabel={'transportadora_name'}
            filter={true}
          />
        </div>
        <div className="p-col-6">
          <CustomDropdown
            label={'Dono do Patrimonio :*'}
            value={movimentacao.selectedPatrimonioOwner}
            onChange={value => {
              setMovimentacao(prevState => ({ ...prevState, selectedPatrimonioOwner: value }))
            }}
            options={owners}
            optionLabel={'owner_name'}
            filter={true}
            disabled={!!movimentacao.id}
          />
        </div>
        <div className="p-col-12">
          <CustomInputTextArea
            rows={5}
            label="Observações"
            marginTop={0}
            value={movimentacao.observacoes}
            onChange={value => {
              setMovimentacao(prevState => ({ ...prevState, observacoes: value }))
            }}
          />
        </div>
        <div className="p-col-12">
          <DataTable
            loading={isLoading}
            value={ativosByOwner}
            emptyMessage={'Não existe ativo associado a esta Operação Logística '}
            paginator={true}
            rows={5}
          >
            <Column field={'ativo_name'} header={'Ativo Patrimonial'} />
            <Column
              field={'qte'}
              header={'Qte'}
              body={ativo => (
                <InputNumeroDecimal
                  value={ativo.qte}
                  decimalScale={0}
                  onChange={value => onQuantidadeChange(ativo, value)}
                  marginTop={0}
                />
              )}
              style={tableCellCentered(100)}
            />
          </DataTable>
        </div>
        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClick} isLoading={isLoading}>
            Salvar
          </Btn>
        </div>
      </div>
    </CustomModal>
  )
}
